import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const SchoolListItemContainer = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SchoolLink = styled(Link)`
  text-decoration: none;
`;

export const SchoolInfo = styled.div`
  font-family: var(--font-sans);
  color: var(--color-black);

  .school-title {
    font-size: 1.25rem;
    font-weight: 500;

    margin-bottom: 8px;
  }
`;
